import React from 'react'
import MarkdownIt from 'markdown-it'
import { cn } from '@workspace/ui/lib/utils'
import { SafeHtml } from '../SafeHtml'

const md = new MarkdownIt({
    html: true,
    linkify: false,
    typographer: true,
})

interface HighlightedTextProps {
    text: string | null | undefined
    highlight?: string[] | null
    className?: string
}

export function HighlightedText({ text, highlight, className }: HighlightedTextProps) {
    const rawContent = (highlight && highlight.length > 0 ? highlight[0] : text) || ''
    if (!rawContent) return null
    const contentToRender = md.renderInline(rawContent)

    return (
        <SafeHtml
            className={cn('pointer-events-none', className)}
            html={contentToRender}
            sanitizeOptions={{
                ALLOWED_TAGS: ['em', 'strong', 'b', 'i'],
                ALLOWED_ATTR: [],
            }}
        />
    )
}
